import Tab from "./Tab";
import { destinations, NavigationProps } from "../navigation";
import styles from "../styles/TabsBar.module.css";

/** Renders the shared destinations as desktop editor tabs. */
export default function TabsBar(params: NavigationProps) {
	return (
		<nav className={styles.tabs} aria-label="File tabs" data-editor-navigation>
			{destinations.map(({ name, filename, icon }) => (
				<Tab key={name} icon={`/${icon}`} filename={filename} name={name} {...params} />
			))}
		</nav>
	);
}
